import React from "react";
import axios from "axios";

export const monthNameArr = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const TableHandler = ({ callback, limit, last, index, length }) => {
  const valueHandler = (isNext) => {
    if (isNext) {
      if (length > last) {
        callback({ index: last, last: last + limit });
      }
    } else {
      if (index > 0) {
        callback({ index: index - limit, last: index });
      }
    }
  };

  const totalPages = Math.ceil(length / limit);

  return (
    <>
      <div className="keyword-pagination">
        <button
          className={"cm-btn_2 me-3 "}
          onClick={() => valueHandler(false)}
        >
          Prev
        </button>
        <span className="me-3">
          Page {Math.ceil(index / limit) + 1} of {totalPages}
        </span>
        <button
          className={`cm-btn_2 ${length <= last ? "disabled" : ""}`}
          onClick={() => valueHandler(true)}
          disabled={length <= last}
        >
          Next
        </button>
      </div>
    </>
  );
};

export const curday = function (sp) {
  const today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //As January is 0.
  var yyyy = today.getFullYear();
  if (dd < 10) dd = "0" + dd;
  return monthNameArr[today.getMonth()] + " " + dd + " , " + yyyy;
};

export const perday = function (sp) {
  const today = new Date();
  var dd = today.getDate();
  var yyyy = today.getFullYear();
  if (dd < 10) dd = "0" + dd;
  return monthNameArr[today.getMonth() + 1] + " " + dd + " , " + yyyy;
};

const updatelang = async (email) => {
  if (!email) return;
  const language = localStorage.getItem("APP_LANG");

  const payload = {
    email,
    language,
  };

  try {
    const response = await axios.post(
      `https://app.rankspro.io/api/user/updatelang/`,
      payload
    );
  } catch (error) {
    console.log("language not updated");
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("APP_LANG", payload.language);
    window.location.href = "/login";
  }
};

export const Logout = (email) => {
  if (email) {
    updatelang(email);
  } else {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  }
};

export function getMonthName(num) {
  return monthNameArr[num - 1];
}

export function formatDate(date) {
  const today = new Date(date);
  var dd = today.getDate();
  var yyyy = today.getFullYear();
  if (dd < 10) dd = "0" + dd;
  return monthNameArr[today.getMonth()] + " " + dd + "," + yyyy;
}

export const DateFormat = (date) => {
  const dateObject = new Date(date);

  if (isNaN(dateObject)) {
    return "Invalid Date"; // Or handle as needed
  }

  // Extract date components
  const year = dateObject.getFullYear();
  const month = dateObject.getMonth() + 1; // Months are zero-indexed
  const day = dateObject.getDate();

  // Extract time components
  let hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();

  // Determine AM/PM and adjust hour for 12-hour format
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12; // Convert to 12-hour format
  hours = hours ? hours : 12; // The hour '0' should be '12'

  // Return formatted string
  return `${year}-${month < 10 ? "0" : ""}${month}-${
    day < 10 ? "0" : ""
  }${day}, ${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
};

export function getFormattedDate() {
  // Get date components
  const today = new Date();
  const date = today.getDate().toString().padStart(2, "0");
  const month = monthNameArr[today.getMonth()];
  const year = today.getFullYear().toString();

  // Return formatted date object
  return {
    date,
    month,
    year,
  };
}
